module.exports = __webpack_public_path__ + "img/kawazoe.e3f4d218.png";